export default __webpack_public_path__ + "static/media/handprint-32-33-page.349fda9b.png";